export default function ProfessionalismCard() {
    return (
        <div className="border rounded-lg overflow-hidden">
            <div className="flex items-center gap-2 p-4 border-b">
                <div className="bg-purple-100 p-1 rounded">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-purple-500"
                    >
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                </div>
                <h3 className="font-medium">Professionalism score</h3>
            </div>

            <div className="p-4 bg-gray-50">
                <div className="flex justify-between items-center mb-4">
                    <div className="text-purple-800 font-bold text-3xl">
                        9.8
                    </div>
                    <div className="text-gray-500 text-sm">
                        Thorough Professional
                    </div>
                </div>

                <p className="text-sm text-gray-600 mb-4">
                    Can understand the main points of clear texts on familiar
                    topics
                </p>

                <p className="text-xs text-gray-500 mb-4">
                    Scores are determined based on general diligence and
                    adherence to the code of conduct.
                </p>

                <div className="flex items-center gap-1 text-xs text-gray-500">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                        ></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>As of 22 Jan 2025</span>
                </div>
            </div>
        </div>
    )
}
